import { capitalizeSentenceIfLower, sortReplies } from '@btime/helpers'
import React from 'react'

import { formatBlockReplies } from '../../../../containers/dynamic/presentationList/_helpers/formatBlocks'
import { useGroupedRepliesByCategory } from '../../../../containers/dynamic/presentationList/categories/_data/groupByCategories'
import { useReplies } from '../_load/FormReplyLoader'
import Bar from '../../../../components/pdf/Bar'
import Reply from '../../../../components/pdf/Reply'
import Separator from '../../../../components/pdf/Separator'
import Text from '../../../../components/pdf/Text'

const Replies = ({ replies }) => {
  replies = formatBlockReplies(replies)

  return replies.map(reply => <Reply key={reply.id} reply={reply} />)
}

const RepliesSection = () => {
  const replies = useReplies()
  const categories = useGroupedRepliesByCategory(sortReplies(replies))

  return categories.map(category => (
    <div key={category.id}>
      <Separator weight={8} />
      <Bar>
        <Text size="h5" bold>
          {capitalizeSentenceIfLower(category.name)}
        </Text>
      </Bar>

      <Separator weight={4} />

      <Replies replies={category.replies} />
    </div>
  ))
}

export default RepliesSection
